import { render, staticRenderFns } from "./MagicBoxIcon.vue?vue&type=template&id=5b0f1a79&scoped=true"
import script from "./MagicBoxIcon.vue?vue&type=script&lang=js"
export * from "./MagicBoxIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0f1a79",
  null
  
)

export default component.exports